import { ChangeDetectionStrategy, ChangeDetectorRef, effect, Component, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AppUtilityService } from '../app.service';
import { UserInfoService } from '../user/user-info.service';
import { IdleService } from './idle.service';

//ng-idle does not work on zoneless enviornment, so we need to make sure the code will not be called when zoneless is enabled.
@Component({
	selector: 'app-idle',
	templateUrl: './idle.component.html',
	providers: [IdleService],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class IdleComponent {
	lastPing?: Date = null;
	idleCtrlId: string = AppUtilityService.newId();

	@ViewChild('idleWaring', { static: true }) idleWaring: TemplateRef<any>;
	warningDuration: number = this.idleService.config.WarningnForSeoncds;
	warningProgress: number = 0;
	percent: string = '0';
	checkAlive: any = null;
	progressBar: any = null;

	constructor(
		private cdr: ChangeDetectorRef,
		private dialog: MatDialog,
		private idleService: IdleService,
		private router: Router,
		private userInfo: UserInfoService
	) {
		effect(() => {
			if (this.idleService.isIdle()) {
				if (this.userInfo.isAnonymous()) {
					this.idleService.reset();
					this.dialog.closeAll();
					return;
				}
				this.dialog.open(
					this.idleWaring,
					{ maxWidth: '500px', disableClose: true, autoFocus: true }
				);

				let timeleft: number = this.warningDuration;
				this.progressBar = setInterval(() => {
					timeleft = timeleft - 1;
					this.warningProgress = this.warningDuration - timeleft;
					this.warningProgress = this.warningProgress > this.warningDuration ? this.warningDuration : this.warningProgress;
					this.percent = (this.warningProgress / this.warningDuration * 100).toFixed(0);
					this.cdr.markForCheck();
					if (this.warningProgress >= this.warningDuration) {
						clearInterval(this.progressBar);
						this.logout();
					}
				}, 1000);
			}
		});

		// check if any other tab still active
		let idleStart = new Date().toUTCString();
		this.checkAlive = setInterval(() => {
			try {
				var idleTime = JSON.parse(localStorage.getItem("idleTime"));
				// close warning if the new time is found and not issued from self
				if (idleTime.ctrlId !== this.idleCtrlId && new Date(idleTime.time) > new Date(idleStart)) {
					if (this.progressBar != null) {
						clearInterval(this.progressBar);
					}
					clearInterval(this.checkAlive);
					this.dialog.closeAll();
				}
			}
			catch (ex) { ; }
			this.cdr.markForCheck();
		}, 30000);
	}

	logout(): void {
		this.dialog.closeAll();
		if (this.router.url.toLocaleLowerCase().indexOf("/landing/") >= 0) {
			this.userInfo.clearProfile(false);
		}
		else {
			this.userInfo.clearProfile(true);
		}
	}

	stayActive(): void {
		if (this.checkAlive != null) {
			clearInterval(this.checkAlive);
		}
		if (this.progressBar != null) {
			clearInterval(this.progressBar);
		}
		this.dialog.closeAll();
		this.idleService.reset();
		//announce users want to stay
		this.lastPing = new Date();
		localStorage.setItem("idleTime", JSON.stringify({ "ctrlId": this.idleCtrlId, "time": this.lastPing.toUTCString() }));
	}
}
